export default __webpack_public_path__ + "static/media/phoneMessage.c0113d76.PNG";